import { Button, Link, Text } from '@chakra-ui/react'
import { Breakpoint } from 'presentation/components/Breakpoint'
import { CHOOSE_PLAN_PATH, hasLegacyPastDueInvoice, redirectToChoosePlan } from 'presentation/main/globalModals/FailedInvoiceModal/legacyPastDuePlan'
import { handleDefaultOpenFailedInvoiceModal } from 'presentation/main/globalModals/FailedInvoiceModal/handleDefaultOpenFailedInvoiceModal'
import { unmaskFailedInvoiceFragment } from 'presentation/main/globalModals/FailedInvoiceModal/unmaskFailedInvoiceFragment'
import { BasePaymentRow } from 'presentation/screens/Billing/components/BillingHistorySection/PaymentsTable/BasePaymentRow/BasePaymentRow'
import { ActiveSubscription } from 'presentation/screens/Billing/components/BillingHistorySection/usePaymentsTable'
import { FC } from 'react'
import { formatPenniesOptionalDecUsdOr } from 'utils/dataAdapter'

export const FailedNextPaymentRow: FC<{
  subscription: ActiveSubscription
}> = ({ subscription }) => {
  const failedInvoiceSummary = unmaskFailedInvoiceFragment(subscription)
  const isLegacyPlan = subscription.plan?.product?.isLegacy ?? false
  const hasLegacyInvoice = hasLegacyPastDueInvoice({
    failedInvoiceSummary,
    isLegacyPlan,
  })
  const invoice = subscription.pastDueInvoice

  if (!invoice) return null

  const price = invoice.refundedAmount
    || invoice.capturedAmount
    || invoice.authorizedAmount
    || undefined

  const handlePayNow = (e: React.MouseEvent<unknown>): void => {
    e.stopPropagation()

    if (hasLegacyInvoice) {
      redirectToChoosePlan()
      return
    }

    handleDefaultOpenFailedInvoiceModal({
      failedInvoiceSummary,
      isLegacyPlan,
    })
  }

  return (
    <BasePaymentRow
      dateString={invoice.paidAt || invoice.createdAt}
      createdById={invoice.createdBy?.id}
      linkToPdf={invoice.linkToPdf || undefined}
      amount={price}
      description={(
        <>
          {hasLegacyInvoice
            ? (
              <>
                Your previous Propelio plan is no longer available.
                {WHITE_SPACE}
                <Link href={CHOOSE_PLAN_PATH} textStyle='body2-h-b' color='link.500' onClick={handlePayNow}>Choose Plan</Link>
                {WHITE_SPACE}
                to continue service.
              </>
            )
            : (
              <>
                Your Propelio subscription of
                {' '}
                {formatPenniesOptionalDecUsdOr('unknown amount')(price)}
                {' '}
                is
                {WHITE_SPACE}
                <Text as='span' textStyle='body2-h-b' color='negative.500'>past due</Text>
                .
                {WHITE_SPACE}
                <Link href='#' textStyle='body2-h-b' color='link.500' onClick={handlePayNow}>Pay Now</Link>
                {WHITE_SPACE}
                to keep service.
              </>
            )}
        </>
      )}
      status={(
        <Button
          variant='solid'
          colorScheme={hasLegacyInvoice ? 'positive' : 'negative'}
          size='xs-narrow'
          onClick={handlePayNow}
          ml='-2'
        >
          <Breakpoint
            mobSm={() => <>{hasLegacyInvoice ? 'Choose' : 'Pay'}</>}
            tabSm={() => <>{hasLegacyInvoice ? 'Choose Plan' : 'Pay Now'}</>}
          />
        </Button>
      )}
    />
  )
}

const WHITE_SPACE = <Text as='span' whiteSpace='pre-wrap'> </Text> // fixes the pesky space that won't render
